import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-data-grid/lib/styles.css';
import './Assets/css/app.css';

import store from './Store';
import AppRoutes from './Routes';
import ErrorBoundary from './ErrorBoundary';
import { installAuthKeepAlive } from './Api/BaseApi';
import { toast } from 'react-toastify';

// One keepalive per browser tab and one explanation after a genuine expiry.
function SessionLifecycle() {
  useEffect(() => {
    const removeKeepAlive = installAuthKeepAlive();
    const url = new URL(window.location.href);
    if (url.pathname === '/login' && url.searchParams.get('session') === 'expired') {
      toast.error('Your R4D login has expired. Please sign in again.', {
        toastId: 'r4d-auth-expired',
        autoClose: 8000,
      });
      url.searchParams.delete('session');
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
    return removeKeepAlive;
  }, []);
  return null;
}

// Create theme
const theme = createTheme({
  typography: { useNextVariants: true },
});

// Render app
ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <ClearBrowserCacheBoundary auto fallback="Loading" duration={60000}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Router>
            <AppRoutes />
            <SessionLifecycle />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Router>
        </Provider>
      </ThemeProvider>
    </ClearBrowserCacheBoundary>
  </ErrorBoundary>,
);
